const WORDS = ["Nursing Algebra", "Books", "Arts", "Leadership"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-[#050505] py-8 overflow-hidden select-none"
    >
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-5xl md:text-7xl uppercase text-white/90 px-8">
              {w}
            </span>
            <span className="text-[#7C3AED] text-4xl md:text-6xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
